import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { Pill } from 'ui-components/components/pill';
import { Marketplace } from '../../../../../src/containers/orders-filter-bar-container/filter-options/options/marketplace';
import { Tag } from '../../../../../src/containers/orders-filter-bar-container/filter-options/options/tag';
import { OrderDate } from '../../../../../src/containers/orders-filter-bar-container/filter-options/options/order-date';
import { BeforeXDays } from '../../../../../src/store/orders/filtering/date-time-filter-operators';
import style from './style.module.less';

export const SORT_FIELD_TOTAL = 'CalculatedTotal';
export const SORT_FIELD_DATE = 'OrderDate';

export const EDITOR_TYPE_CUSTOM = 'Custom';
export const EDITOR_TYPE_TAG = 'OrderTag';
export const EDITOR_TYPE_ORDER_PLACED = 'OrderPlaced';
export const EDITOR_TYPE_MARKETPLACE = 'Marketplace';

const defaultName = 'Prioritize orders from';

export const getRulePrioritizationText = (sortDesc, sortField) => {
  if (sortField === SORT_FIELD_TOTAL && sortDesc) {
    return <FormattedMessage {...messages.allocationStrategiesHighestOrderTotal} />;
  }
  if (sortField === SORT_FIELD_TOTAL && !sortDesc) {
    return <FormattedMessage {...messages.allocationStrategiesLowestOrderTotal} />;
  }
  if (sortField === SORT_FIELD_DATE && sortDesc) {
    return <FormattedMessage {...messages.allocationStrategiesNewestOrders} />;
  }
  if (sortField === SORT_FIELD_DATE && !sortDesc) {
    return <FormattedMessage {...messages.allocationStrategiesOldestOrders} />;
  }
};

const getFirstCollectionFilterValue = (filterSet) => {
  const filter = filterSet?.appliedFilters?.collectionFilters[0];
  const { values } = filter;
  const [value] = values;
  return value;
};

export const getUpdatedCollectionFilter = (updateValue, filterSet) => {
  const collectionFilter = {
    ...filterSet?.appliedFilters?.collectionFilters[0],
    values: [updateValue],
  };
  return {
    ...filterSet,
    appliedFilters: {
      ...filterSet.appliedFilters,
      collectionFilters: [collectionFilter],
    },
  };
};

export const getUpdatedDateTimeFilter = (updateValue, filterSet) => {
  const filter = {
    ...filterSet?.appliedFilters?.dateTimeFilters[0],
    value: updateValue,
  };
  return {
    ...filterSet,
    appliedFilters: {
      ...filterSet.appliedFilters,
      dateTimeFilters: [filter],
    },
  };
};

export const selectedTagForFilterSet = (filterSet, sellerTags) => {
  return sellerTags.find((atag) => atag.tagId === getFirstCollectionFilterValue(filterSet));
};

export const selectedMarketPlaceForFilterSet = (filterSet, marketPlaces) => {
  return marketPlaces.find((mkt) => mkt.marketplaceId === parseInt(getFirstCollectionFilterValue(filterSet), 10));
};

export const selectedValueForOrderPlaced = (filterSet) => {
  const filter = filterSet?.appliedFilters?.dateTimeFilters[0];
  const { value } = filter;
  return value;
};

export const getRuleNameFromEditorType = (ruleName, editorType, filterSet, sellerTags, marketPlaces) => {
  if (editorType === EDITOR_TYPE_CUSTOM || !filterSet) {
    return ruleName;
  }
  if (editorType === EDITOR_TYPE_TAG) {
    const tag = selectedTagForFilterSet(filterSet, sellerTags);
    return (
      <div>
        <FormattedMessage {...messages.allocationStrategiesTagName} />
        <Pill className={style.pill} collapsed color={tag.hexColor} label={tag.name} />
        <span className={style['tag-name']}>{tag.name}</span>
      </div>
    );
  }
  if (editorType === EDITOR_TYPE_ORDER_PLACED) {
    const value = selectedValueForOrderPlaced(filterSet);
    return <FormattedMessage {...messages.allocationStrategiesOrderPlaced} values={{ a: (chunks) => chunks, value }} />;
  }
  if (editorType === EDITOR_TYPE_MARKETPLACE) {
    const marketPlace = selectedMarketPlaceForFilterSet(filterSet, marketPlaces);
    return (
      <FormattedMessage
        {...messages.allocationStrategiesOrderMarketplace}
        values={{
          b: (chunks) => <b>{chunks}</b>,
          storeName: marketPlace?.name,
        }}
      />
    );
  }
};

export const getNewAllocationRule = (editorType, allocationStrategyId, orderFilterSetId, task) => {
  return {
    isActive: true,
    allocationRuleId: 0,
    allocationStrategyId,
    editorType,
    filterId: orderFilterSetId,
    name: defaultName,
    sortDesc: false,
    sortField: SORT_FIELD_DATE,
    task,
    taskPriority: 1,
  };
};

const getCollectionFilter = (column, defaultValue, orderFilterSetId) => {
  return {
    orderFilterSetId,
    active: false,
    name: defaultName,
    appliedFilters: {
      collectionFilters: [
        {
          column,
          isIn: true,
          values: [defaultValue],
        },
      ],
    },
  };
};

export const getNewMarketplaceFilter = (defaultMarketplaceId, orderFilterSetId) => {
  return getCollectionFilter(Marketplace.filterValue, defaultMarketplaceId, orderFilterSetId);
};

export const getNewTagsFilter = (defaultTagId, orderFilterSetId) => {
  return getCollectionFilter(Tag.filterValue, defaultTagId, orderFilterSetId);
};

export const getNewDateFilter = (orderFilterSetId) => {
  return {
    orderFilterSetId,
    active: false,
    name: defaultName,
    appliedFilters: {
      dateTimeFilters: [
        {
          column: OrderDate.filterValue,
          operator: BeforeXDays,
          value: 1,
        },
      ],
    },
  };
};
